import clsx from "clsx";
import { useId } from "react";
import styles from "./InputField.module.scss";

type IControlledInputBase = {
  value: string | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  type?: React.HTMLInputTypeAttribute;
  size?: "default" | "compact";
};

/**
 * `showLabelAsPlaceholder` may only be used when the label is hidden. Only set it when the value
 * is still understandable without a visible label (e.g. search fields).
 */
type IControlledInput =
  | (IControlledInputBase & {
      hideLabel: true;
      showLabelAsPlaceholder?: boolean;
    })
  | (IControlledInputBase & {
      hideLabel?: false;
      showLabelAsPlaceholder?: never;
    });

const ControlledInput = ({
  value,
  onChange,
  label,
  hideLabel,
  showLabelAsPlaceholder,
  type,
  size = "default",
}: IControlledInput) => {
  const id = useId();
  const showPlaceholder = hideLabel === true && Boolean(showLabelAsPlaceholder);

  return (
    <div className={clsx(styles.inputFieldWrapper)}>
      {hideLabel ? null : label ? (
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      ) : null}
      <div
        className={clsx(
          styles.inputWrapper,
          styles[`size-${size}`],
          hideLabel && styles.hiddenLabel,
        )}
      >
        <input
          id={id}
          value={value}
          placeholder={showPlaceholder ? label : undefined}
          onChange={onChange}
          aria-label={hideLabel && label ? label : undefined}
          className={styles.input}
          type={type}
        />
      </div>
    </div>
  );
};

export default ControlledInput;
